import { Location } from '@reach/router';
import { Link } from 'gatsby';
import React, { FC } from 'react';
import styled from 'styled-components';
import useScrollMonitor from '../../utils/hooks/useScrollMonitor';
import { darkGray, lightGray } from '../../utils/styles';
import { Breadcrumb, Section } from './';

export const HEADER_HEIGHT = '60px';

const StyledHeader = styled.header`
  height: ${HEADER_HEIGHT};
  width: 100%;
  display: flex;
  align-items: center;

  h4 {
    margin: 0;
    a:hover {
      color: ${darkGray};
    }
  }
`;

const HeaderSection = styled(Section)<{ scrolled: boolean }>`
  position: sticky;
  top: 0;
  z-index: 1;
  transition: box-shadow 0.3s;
  // display: flex;
  ${({ scrolled }) => (scrolled ? `box-shadow: ${lightGray} 0 1px 2px;` : '')}
`;

// const FollowButton = styled(StyledButton)`
//   border: solid ${primaryColorLight} 1px;
//   color: ${primaryColor};
//   align-self: right;
//   &:focus,
//   &:hover {
//     border: solid ${primaryColor} 1px;
//   }
// `;

export const Header: FC = () => {
  const hasScrolled = useScrollMonitor();
  return (
    <Location>
      {({ location }) => (
        <HeaderSection scrolled={hasScrolled}>
          <StyledHeader>
            <h4>
              <Link to="/">best people at </Link>
              <Breadcrumb pathname={location.pathname} />
            </h4>
          </StyledHeader>
        </HeaderSection>
      )}
    </Location>
  );
};

export default Header;
